// 操作(write→結果待ち→確定)の進行段階。platform ShareProcessState の spot 版。
// 接続の進行(BleConnectionPhase)とは別軸: こちらは「取引の完了にどこまで近いか」を表す。
export type StandOperationStage = 'idle' | 'writing' | 'wrote' | 'settled'

export type StandOperationState = {
  stage: StandOperationStage
  // = capabilities.canDistinguishReaders(先開錠)。後開錠 legacy では常に false。
  offerManualCompletion: boolean
}

export const IDLE_OPERATION_STATE: StandOperationState = {
  stage: 'idle',
  offerManualCompletion: false,
}

// platform share_process_state.dart:55 の写し: 表示可否は state から導出し、
// 画面側に独自の表示条件を持たせない。
export function allowsManualComplete(state: StandOperationState): boolean {
  return state.stage === 'wrote' && state.offerManualCompletion
}

// stage は1操作の中で前進のみ(idle→writing→wrote→settled・後退なし)。
// 複数のイベント(write ack・結果フレーム・claim)がそれぞれ自分の発生時に
// 遷移を試みるため、到着順の入れ替わりで状態が巻き戻らないことを
// 順位比較で保証する。
const STAGE_ORDER: Record<StandOperationStage, number> = {
  idle: 0,
  writing: 1,
  wrote: 2,
  settled: 3,
}

export function stageAdvances(
  from: StandOperationStage,
  to: StandOperationStage
): boolean {
  return STAGE_ORDER[to] > STAGE_ORDER[from]
}
